import { Box } from '@mui/material';
import { awayDashOf } from './dash';
import type { ChartSeries, PanelId } from './seriesTypes';

const SWATCH_SIZE = 8;
// Wide enough for two dashes of the away pattern.
export const DASHED_SWATCH_WIDTH = 18;

/**
 * The colour mark in front of a legend or a tooltip row: a square, or, for a
 * line that is drawn dashed because it is away from home, a short piece of
 * that line. With `slot` it sits at the left of a slot as wide as the dashed
 * mark, for a list of rows where some marks are dashed, so their labels line up.
 */
export function SeriesSwatch({
    series,
    panelId,
    slot = false,
}: {
    series: ChartSeries;
    panelId: PanelId;
    slot?: boolean;
}) {
    const dash = awayDashOf(series, panelId);
    const mark =
        dash === undefined ? (
            <Box
                sx={{
                    width: SWATCH_SIZE,
                    height: SWATCH_SIZE,
                    borderRadius: '2px',
                    bgcolor: series.color,
                    flexShrink: 0,
                }}
            />
        ) : (
            <svg
                width={DASHED_SWATCH_WIDTH}
                height={SWATCH_SIZE}
                aria-hidden="true"
                style={{ flexShrink: 0 }}
            >
                <line
                    x1={0}
                    x2={DASHED_SWATCH_WIDTH}
                    y1={SWATCH_SIZE / 2}
                    y2={SWATCH_SIZE / 2}
                    stroke={series.color}
                    strokeWidth={2}
                    strokeDasharray={dash}
                />
            </svg>
        );
    if (!slot) return mark;
    return (
        <Box
            data-testid="series-swatch-slot"
            sx={{
                width: DASHED_SWATCH_WIDTH,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {mark}
        </Box>
    );
}
